// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fixDates = (obj: any, fields: string[]) => {
    fields.forEach(key => {
        if (obj[key]) {
            obj[key] = new Date(obj[key]);
        }
    });
};
